import { isNullOrWhitespace, strCompareLowerCase } from "@common/Common";
import PortfolioOrDecisionNavigation from '@common/Components/PortfolioOrDecisionNavigation.vue';
import { ICommandStatus } from '@cqrs/cqrs';
import { RequestUserAccessCommandV1 } from '@Organizations/Users/commands-core';
import UsersCommands from "@Organizations/Users/commands-vue-component";
import UsersQueries from "@Organizations/Users/queries-vue-component";
import { ProjectUsersTagsManagerViewModel } from '@Projects/Components/ProjectUsersTagsManager';
import ProjectUsersTagsManager from '@Projects/Components/ProjectUsersTagsManager.vue';
import { CreateProjectUsersTagCommandV1, DeleteProjectUsersTagCommandV1, UpdateProjectUsersTagCommandV1 } from '@Projects/Domain/commands-core';
import ProjectCommands from "@Projects/Domain/commands-vue-component";
import ProjectQueries from "@Projects/Domain/queries-vue-component";
import { ProjectUsersTagsReadModel } from '@Projects/Domain/readmodels';
import { ProjectUser } from '@Projects/Model';
import { ProjectUserDeleterViewModel } from '@ProjectUsers/Components/ProjectUserDeleter';
import ProjectUserDeleter from '@ProjectUsers/Components/ProjectUserDeleter.vue';
import { ProjectUsersFromStringBuilderViewModel } from '@ProjectUsers/Components/ProjectUsersFromStringBuilder';
import ProjectUsersFromStringBuilder from '@ProjectUsers/Components/ProjectUsersFromStringBuilder.vue';
import { ArchiveProjectUserCommandV1, CreateProjectUsersCommandV1, DeleteProjectUserCommandV1, UnarchiveProjectUserCommandV1, UpdateProjectUserCommandV1 } from '@ProjectUsers/Domain/commands-core';
import ProjectUsersCommands from "@ProjectUsers/Domain/commands-vue-component";
import ProjectUsersQueries from "@ProjectUsers/Domain/queries-vue-component";
import { PeoplePageReadModel, ProjectUserDependenciesReadModel, ProjectUserReadModel, ProjectUsersReadModel } from '@ProjectUsers/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';
import { dynamicUiRoutes } from "@common/dynamicUiRoutes";

@Component({ components: { PortfolioOrDecisionNavigation, ProjectUserDeleter, ProjectUsersFromStringBuilder, ProjectUsersTagsManager } })
export default class PeoplePage extends mixins(ProjectUsersCommands, ProjectUsersQueries, ProjectCommands, ProjectQueries, UsersCommands, UsersQueries)
{
    get projectId(): number { return Number.parseInt(this.$route.params.projectId) }
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId) }
    get url_ManageAssignmentsPage(): string { return dynamicUiRoutes.Alternatives_ManageAssignmentsPage(this.$route, this.workspaceId, this.projectId); }

    email: string = null;
    initialized: boolean = false;
    organizationUnitId: number = null;
    searchPhrase: string = null;
    projectUsers: ProjectUserVM[] = null;
    tags: string[] = null;
    tagFilter: string = null;
    archivedFilter: boolean = false;
    alternativesLabel: string | null = null;

    projectUserDeleter: ProjectUserDeleterViewModel = new ProjectUserDeleterViewModel();
    projectUsersFromStringBuilder: ProjectUsersFromStringBuilderViewModel = new ProjectUsersFromStringBuilderViewModel();
    projectUsersTagsManager: ProjectUsersTagsManagerViewModel = new ProjectUsersTagsManagerViewModel();
    
    get selectedUsersCount(): number { return this.projectUsers.filter(a => a.IsSelected).length; }
    get noneSelected(): boolean { return !this.projectUsers.some(a => a.IsSelected); }
    get allSelected(): boolean { return !this.projectUsers.some(a => !a.IsSelected); }
    get anySelected(): boolean { return this.projectUsers.some(a => a.IsSelected); }
    get projectUsersView(): ProjectUserVM[]
    {
        if (this.projectUsers == null)
        {
            return null;
        }

        let view = this.projectUsers.filter(a => a.IsArchived === this.archivedFilter);

        if (!isNullOrWhitespace(this.searchPhrase))
        {
            const phrase = this.searchPhrase.toLowerCase();
            view = view.filter(a => (a.Name + a.Email).toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.tagFilter)
        {
            view = view.filter(a => a.Tags.indexOf(this.tagFilter) > -1);
        }

        view = view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));

        return view;
    }


    showProjectUsersFromStringBuilder()
    {
        this.projectUsersFromStringBuilder.show(this.tags);
    }

    showTagsManager()
    {
        this.projectUsersTagsManager.show(this.tags);
    }

    showProjectUserDeleter(vm: ProjectUserVM)
    {
        this.runProjectUserDependenciesQueryV1(this.workspaceId, this.projectId, vm.ProjectUserId);
        this.projectUserDeleter.show(vm.ProjectUserId, vm.Name);
    }

    selectAll()
    {
        this.projectUsers.forEach(a => a.IsSelected = true);
    }

    inverseSelection()
    {
        this.projectUsers.forEach(a => a.IsSelected = !a.IsSelected);
    }

    unselectAll()
    {
        this.projectUsers.forEach(a => a.IsSelected = false);
    }


    handleRequestAccount(vm: ProjectUserVM)
    {
        this.invokeRequestUserAccessCommandV1(vm.Email, this.organizationUnitId, this.email, vm.Email, null, null, vm.Name)
    }

    handleUpdateProjectUserCommand(vm: ProjectUserVM)
    {
        if (isNullOrWhitespace(vm.NewName))
        {
            vm.NameError = "Name is required";
            return;
        }

        this.invokeUpdateProjectUserCommandV1(this.workspaceId, this.projectId, vm.ProjectUserId, vm.NewName, vm.NewEmail, vm.NewTags, vm.Name, vm.Email, vm.Tags);
        //vm.Editing = false;
    }

    handleResetProjectUserAccessTokenCommand(vm: ProjectUserVM)
    {
        if (confirm(`Are you sure you want to reset all access links for: ${vm.Name}?`))
        {
            this.invokeResetProjectUserAccessTokenCommandV1(this.workspaceId, this.projectId, vm.ProjectUserId);
        }
    }

    handleUnarchiveProjectUserCommand(vm: ProjectUserVM)
    {
        this.invokeUnarchiveProjectUserCommandV1(this.workspaceId, this.projectId, vm.ProjectUserId);
    }

    handleDeleteProjectUserCommand(projectUserId: number)
    {
        this.invokeDeleteProjectUserCommandV1(this.workspaceId, this.projectId, projectUserId);
    }

    handleArchiveProjectUserCommand(projectUserId: number)
    {
        this.invokeArchiveProjectUserCommandV1(this.workspaceId, this.projectId, projectUserId);
    }

    handleCreateProjectUsersCommand(pus: ProjectUser[])
    {
        this.invokeCreateProjectUsersCommandV1(this.workspaceId, this.projectId, pus);
    }

    handleCreateProjectUsersTagCommand(tag: string)
    {
        this.invokeCreateProjectUsersTagCommandV1(this.workspaceId, this.projectId, tag);
    }

    handleDeleteProjectUsersTagCommand(tag: string)
    {
        if (confirm(`Are you sure you want to delete tag: ${tag}?`))
        {
            this.invokeDeleteProjectUsersTagCommandV1(this.workspaceId, this.projectId, tag);
        }
    }

    handleUpdateProjectUsersTagCommand(oldTag: string, newTag: string)
    {
        this.invokeUpdateProjectUsersTagCommandV1(this.workspaceId, this.projectId, oldTag, newTag);
    }


    mounted()
    {
        document.title = "People | TransparentChoice";
        this.runCurrentUserQueryV1(false, false, false);
        this.runPeoplePageQueryV1(this.workspaceId, this.projectId);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName == "PeoplePageReadModel") 
        {
            const rm = model as PeoplePageReadModel;

            this.organizationUnitId = rm.OrganizationUnitId;
            this.projectUsers = rm.ProjectUsers.map(a => new ProjectUserVM(a));
            this.tags = rm.ProjectUsersTags;
            this.alternativesLabel = rm.AlternativesLabel;
            this.initialized = true;
        }
        else if (modelName == "ProjectUsersReadModel")
        {
            const rm = model as ProjectUsersReadModel;

            for (const pu of rm.ProjectUsers)
            {
                const curr = this.projectUsers.find(a => a.ProjectUserId === pu.ProjectUserId);

                if (curr == null)
                {
                    this.projectUsers.push(new ProjectUserVM(pu))
                }
                else
                {
                    curr.update(pu);
                }
            }
        }
        else if (modelName == "ProjectUsersTagsReadModel")
        {
            const rm = model as ProjectUsersTagsReadModel;
            this.tags = rm.Tags;
        }
        else if (modelName == "UserSessionDetailsReadModel")
        {
            this.email = model.Email
        }
        else if (modelName == "ProjectUserDependenciesReadModel")
        {
            const rm = model as ProjectUserDependenciesReadModel;
            this.projectUserDeleter.setData(rm);
        }
    }



    onCommandSucceed(cmd: any, correlationId: string)
    {
        if (DeleteProjectUserCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            const pu = this.projectUsers.find(a => a.ProjectUserId === projectUserId);
            this.projectUsers.remove(pu);

            this.projectUserDeleter.close();
        }
        else if (UpdateProjectUserCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            this.projectUsers.find(a => a.ProjectUserId === projectUserId).confirmUpdate();
        }
        else if (CreateProjectUsersCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as CreateProjectUsersCommandV1;

            const localIds = cmd1.ProjectUsers.map(a => a.LocalId);
            this.runProjectUsersByLocalIdsQueryV1(this.workspaceId, this.projectId, localIds);
            this.projectUsersFromStringBuilder.close();
        }
        else if (ArchiveProjectUserCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            this.projectUsers.find(a => a.ProjectUserId === projectUserId).IsArchived = true;

            this.projectUserDeleter.close();
        }
        else if (UnarchiveProjectUserCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            this.projectUsers.find(a => a.ProjectUserId === projectUserId).IsArchived = false;
        }
        else if (CreateProjectUsersTagCommandV1.matchType(cmd))
        {
            const tag = correlationId;
            this.tags.push(tag);
            this.projectUsersTagsManager.addTag(tag);
        }
        else if (DeleteProjectUsersTagCommandV1.matchType(cmd))
        {
            const tag = correlationId;
            this.tags.remove(tag);
            this.projectUsers.forEach(pu => pu.Tags.remove(tag));

            this.projectUsersTagsManager.removeTag(tag);
        }
        else if (UpdateProjectUsersTagCommandV1.matchType(cmd))
        {
            const oldTag = correlationId;
            const updated = this.projectUsers.filter(a => a.Tags.indexOf(oldTag) > -1);

            this.runProjectUsersTagsQueryV1(this.workspaceId, this.projectId);

            if (updated.length > 0)
            {
                this.runProjectUsersByIdsQueryV1(this.workspaceId, this.projectId, updated.map(a => a.ProjectUserId))
            }

            this.projectUsersTagsManager.confirmTagUpdate(oldTag);

        }
        else if (RequestUserAccessCommandV1.matchType(cmd))
        {
            this.runPeoplePageQueryV1(this.workspaceId, this.projectId);
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (RequestUserAccessCommandV1.matchType(status.Command))
        {
            alert('Unable to request an user account. User with this email may already exist or user data is invalid.')
        }
        else if (CreateProjectUsersTagCommandV1.matchType(status.Command))
        {
            for (const error of status.ValidationErrors)
            {
                this.projectUsersTagsManager.showCreateError(error.Error);
            }

        }
        else if (UpdateProjectUsersTagCommandV1.matchType(status.Command))
        {
            for (const error of status.ValidationErrors)
            {
                this.projectUsersTagsManager.showUpdateError(error.Error);
            }
        }
    }
}


class ProjectUserVM
{
    ProjectUserId: number = null;
    IsArchived: boolean = null;
    IsSelected: boolean = false;
    IsUserAccepted: boolean = false;
    IsUserRejected: boolean = false;
    IsUserRequested: boolean = false;
    UserId: number = null;

    Name: string = null;
    Email: string = null;
    Tags: string[] = null;

    NewName: string = null;
    NewEmail: string = null;
    NewTags: string[] = null;

    NameError: string = null;
    EmailError: string = null;

    Editing: boolean = false;
    Deleting: boolean = false;

    constructor(rm: ProjectUserReadModel)
    {
        this.ProjectUserId = rm.ProjectUserId;
        this.Name = rm.Name;
        this.Email = rm.Email;
        this.Tags = rm.Tags;
        this.IsArchived = rm.IsArchived;
        this.IsUserAccepted = rm.IsUserAccepted;
        this.IsUserRejected = rm.IsUserRejected;
        this.IsUserRequested = rm.IsUserRequested;
        this.UserId = rm.UserId;
    }

    update(rm: ProjectUserReadModel)
    {
        this.Name = rm.Name;
        this.Email = rm.Email;
        this.Tags = rm.Tags;
    }

    edit()
    {
        this.NewName = this.Name;
        this.NewEmail = this.Email;

        this.NewTags = [...this.Tags];

        this.Editing = true;
    }

    cancelEdit()
    {
        this.Editing = false;
    }

    confirmUpdate()
    {
        this.Name = this.NewName;
        this.Email = this.NewEmail;
        this.Tags = this.NewTags.map(a => a);

        this.Editing = false;
    }

    removeTag(t: string)
    {
        this.NewTags.remove(t);
    }

    addTag(t: string)
    {
        if (this.NewTags.indexOf(t) === -1)
        {
            this.NewTags.push(t);
        }
    }
}